<template>
    <div
        class="product-select-card container"
        :class="{ 'product-select-card--countdown-wrapper': !!productDetails.availableUntil }"
    >
        <ProductSelectCountdownHeader
            v-if="!!productDetails.availableUntil"
            :available-until="productDetails.availableUntil"
            @expired="isExpired = true"
        />

        <div v-else class="row product-select-card__row">
            <div v-if="hasProductInfo" class="col-12 col-sm-6 d-flex">
                <slot name="left">
                    <div class="d-inline-flex flex-column m-auto product-select-card__title">
                        <Classification
                            v-if="productDetails.hotelClassification"
                            :hotel-classification="productDetails.hotelClassification"
                        />

                        <p v-if="productDetails.hotel" class="mb-0 font-weight-bold">{{ productDetails.hotel }}</p>
                        <p v-else-if="productDetails.title" class="mb-0">{{ productDetails.title }}</p>
                    </div>
                </slot>
            </div>

            <div v-if="$slots.right" class="col-12 col-sm-6 d-flex">
                <slot name="right"> </slot>
            </div>
        </div>
    </div>
</template>

<script>
import Classification from '@/components/Classification.vue';
import Price from '@/components/Price.vue';
import DiscountBadge from '@/components/DiscountBadge.vue';
import ProductSelectHeaderPrice from '@/components/product/selection/ProductSelectHeaderPrice.vue';
import CountdownTimer from '@/components/product/countdown/CountdownTimer.vue';
import ProductSelectCountdownHeader from '@/components/product/countdown/ProductSelectCountdownHeader.vue';

export default {
    name: 'ProductSelectMobileCard',
    components: {
        ProductSelectCountdownHeader,
        CountdownTimer,
        ProductSelectHeaderPrice,
        DiscountBadge,
        Price,
        Classification
    },

    data() {
        return {
            isExpired: false
        };
    },

    props: {
        productDetails: {
            required: true,
            type: Object
        }
    },

    computed: {
        hasProductInfo() {
            return (this.productDetails.hotelClassification && this.productDetails.hotel) || this.productDetails.title;
        }
    },

    watch: {
        isExpired() {
            this.$emit('expired');
        }
    }
};
</script>

<style scoped lang="scss">
.product-select-card {
    background-color: var(--border-color);
    padding: 1rem;

    &--countdown-wrapper {
        background-color: var(--product-select-header-bg);
        color: var(--white);
        text-align: center;
        padding: 2rem;
    }

    &__row {
        row-gap: 10px;
    }

    &__title {
        font-size: 18px;
    }
}
</style>
